import { mapState, mapGetters, mapActions } from 'vuex';
import CatalogService from '@/js/services/productCatalog';

export default {
  data() {
    return {
      keyword: '',
      results: [],
      total: 0,
      page: 1,
      limit: 20,
      loading: false,
      searched: false,
      selectedItems: [],
      store: null, // set in created hook

    };
  },
  computed: {
    ...mapState({
      ownerId: (state) => state.production?.production?.owner,
    }),
    ...mapState('shoppable', [
      'selectedCollection',
    ]),
    ...mapGetters('shoppable', [
      'selectedCollectionData',
    ]),
  
    noResults() {
      return !this.loading && this.searched && !this.results.length;
    },
    pages() {
      if (this.total > 0) {
        return this.total / 10;
      }
  
      return 1;
    },
    savedItemLookup() {
      return this.results.reduce((acc, item) => {
        acc[item.sourceId] = this.isSaved(item) || this.selectedItems.includes(item.sourceId);
        return acc;
      }, {});
    },
    // this is sometimes overridden in the component, but this is the default
    searchQuery() {
      return this.keyword;
    },
  },
  watch: {
    selectedItems() {
      this.$emit('selected', this.selectedItems.length);
    },
  },
  methods: {
    ...mapActions('shoppable', [
      'saveProduct',
    ]),

    clearSearch() {
      this.keyword = '';
      this.results = [];
    },
    isSaved(item) {
      if (this.selectedCollection > 0) {
        return item.collections?.includes(this.selectedCollection);
      }

      return item.isSaved;
    },
    async chooseItem(item) {
      try {
        await this.saveProduct({
          source: this.store,
          sourceId: item.sourceId,
          collectionId: this.selectedCollection,
        });

        this.selectedItems.push(item.sourceId);
      } catch (error) {
        this.errorToast('There was an error saving this product. Please try again.');  
      }
    },

    async keywordSearch(searchPage = 1) {
      if (!this.keyword) return;

      this.loading = true;

      if (searchPage === 1) {
        this.results = [];
        this.selectedItems = [];
      }

      try {
        const { products = [], total } = await CatalogService.search(this.ownerId, this.store, {
          keyword: this.searchQuery,
          ...this.queryParams, // this is set in the component
          page: searchPage,
          limit: this.limit,
        });
        
        this.results = this.results.concat(products);
        this.total = total;
        this.page = searchPage;
      } catch (error) {
        this.errorToast('There was an error searching for products. Please try again.');
        console.error('Error doing shoppable keyword search', error);
      }

      this.loading = false;
      this.searched = true;
    },
    async loadMore() {
      await this.keywordSearch(this.page + 1);
    },
  },
};
